import { ProductPageLayout } from '../components/ProductPageLayout';

export function NanoBananaPage() {
    return <ProductPageLayout productId="nano-banana" />;
}
